import { Migration } from '@mydocma/core/src/lib/migration';
import { IDBPDatabase } from 'idb';
import { MmProjectDbCollections } from '../../mm-project-db-schema';

export const V11: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.createObjectStore(MmProjectDbCollections.attributes,  { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.attributeGroups,  { keyPath: 'Id' });
    database.createObjectStore(MmProjectDbCollections.attributeGroups_files,  { keyPath: 'Id' });
  },

};
